import clsx from 'clsx';
import React from 'react';

type ActiveFilesBadgeProps = {
  count: number;
};

const ActiveFilesBadge = ({ count }: ActiveFilesBadgeProps) => {
  if (!count) {
    return null;
  }

  return (
    <div
      className={clsx(
        'badge--active',
        'tw-flex tw-items-center tw-justify-center',
        'tw-bg-cfo-green-100',
        'tw-font-brandonTextMedium tw-text-cfo-green-300',
        'tw-px-[10px] tw-py-[5px] tw-mx-[5px]',
        'tw-rounded-[34px] tw-leading-[20px]'
      )}
    >
      <span> Active - {count} </span>
    </div>
  );
};

export default ActiveFilesBadge;
